import { createGetColour } from "@/constants/priorityColours"
import { useMemo } from "react"

export function useGetColours() {
  return useMemo(() => createGetColour(), [])
}
